import { render, staticRenderFns } from "./rechercheMedecin.vue?vue&type=template&id=4ef0955b&"
import script from "./rechercheMedecin.vue?vue&type=script&lang=js&"
export * from "./rechercheMedecin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports